module.exports = __webpack_public_path__ + "media/images/mobile-only/element03-104f6db8c834ef3568727a4258fe63eb.png";